import React from "react";

const HLVInfo = () => {
  return (
    <div>
      <div className="text-3xl font-semibold w-full text-center mb-4">
        Human Life Value <span className="text-blue-500">Calculator</span>
      </div>
      <div>
        <p className="mb-6">
          The Human life value involves a complex and thought-provoking
          analysis. Financial planners, insurance professionals, and individuals
          often use the concept of Human Life Value (HLV) to assess the economic
          significance of an individual's life. While assigning a monetary value
          to something as intangible as life may seem challenging, calculating
          HLV can offer valuable insights for financial planning, risk
          management, and determining insurance needs.
        </p>
        <div className="flex justify-center">
          <img
            src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/hlv1.jpg"
            alt="HLV Image"
            className="w-2/3 h-auto rounded-md"
          />
        </div>

        {/* Key Considerations Section */}
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Key Considerations</h2>
          <ul className="list-disc pl-6">
            <li className="mb-2">
              HLV in insurance entails assigning a monetary worth to oneself to
              estimate potential future expenses for loved ones.
            </li>
            <li className="mb-2">
              The initial step involves evaluating the individual's present
              income and their capacity to earn in the future, considering
              factors such as age, education, skills, and career trajectory.
            </li>
            <li className="mb-2">
              Accurate HLV calculation necessitates considering both the
              individual's current living expenses and anticipated future
              expenses.
            </li>
            <li className="mb-2">
              In the unfortunate event of the individual's untimely death,
              identifying the financial requirements of their dependents becomes
              crucial.
            </li>
          </ul>
        </div>

        {/* Overview of HLV Section */}
        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Overview of HLV</h2>
          <p className="mb-4">
            HLV, or Human Life Value, is a metric used by insurers to determine
            the appropriate sum assured. It represents the present value of an
            individual's future income, expenses, liabilities, and assets.
            Calculating HLV aids in understanding the amount needed to protect
            the financial well-being of dependents with term insurance in the
            event of the individual's demise.
          </p>
          <p className="mb-4">
            In insurance, HLV signifies the monetary value attributed to an
            individual to estimate the future expenses of their loved ones,
            factoring in the current inflation rate. This calculation is vital
            to ensuring the financial security of loved ones by covering their
            needs after the individual's passing.
          </p>
        </div>
        {/* Calculating HLV Section */}
        {/* <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4">Calculating HLV</h2>
      <p className="mb-4">
        Determining HLV in insurance involves assessing the family's
        current expenditure. The calculation considers the family's
        current expenses to estimate the future expenses that loved ones
        would incur. The HLV calculator takes into account factors such as
        tax payable, insurance premium, retirement age, number of working
        years, and expected rate of return.
      </p>
      <p className="mb-4">
        For instance, if an individual's annual income is five lakhs, and
        personal expenses are one lakh, the surplus amount of four lakhs
        becomes the economic value for the family. Accounting for tax,
        insurance premium, retirement age, and other factors, the
        calculated HLV might be ₹3.9 lakhs.
      </p>
    </div> */}
        {/* Steps to Calculate HLV Section */}

        <div className="flex justify-center">
          <img
            src="https://acuvisor.s3.ap-south-1.amazonaws.com/dev/Images/Icons/hlv3.jpg"
            alt="HLV Image"
            className="w-3/4 h-auto rounded-md"
          />
        </div>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Steps to Calculate HLV</h2>
          <ol className="list-decimal pl-6">
            <li className="mb-2">
              Evaluate Income and Potential Growth: Assess the individual's
              current income and potential growth over working years,
              considering factors like promotions and career changes.
            </li>
            <li className="mb-2">
              Determine Living Expenses: Identify current and projected living
              expenses, including housing, utilities, healthcare, and education.
            </li>
            <li className="mb-2">
              Calculate Dependents' Financial Needs: Consider dependents' age,
              education expenses, healthcare costs, and outstanding debts.
            </li>
            <li className="mb-2">
              Account for Debt and Liabilities: Include outstanding debts such
              as mortgages, personal loans, and credit card debts.
            </li>
            <li className="mb-2">
              Adjust for Inflation and Discount Rate: Factor in inflation and
              apply a discount rate to future income, expenses, and financial
              needs.
            </li>
            <li className="mb-2">
              Determine the Present Value: Convert future cash flows into
              present values by applying the discount rate.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default HLVInfo;
